module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAABCCAYAAAAsejQrAAAABHNCSVQICAgIfAhkiAAAATBJREFUaIHt2sFtg0AQheEZcA2cc6cIkya2HAyUszSxLoImKIKXC4kIlm3ZmRdAmu8EiwS/0AIHVkVEQgiNiFxkpwAkVb3GGBvde+xKmwE4b13xgstJVavvva7rNmy5r67rn+3T+mBRFP8a88w4jr/2s4063ubBbB7M5sFsHszmwWwezObBbB7M5sFsHszmwWwezObBbB7M5sFsHszmwWwezObBbB7M5sFsHsx2uOCb5Qfr3/17oyEEbB3xips7bKQVEQFwXq54sWAaDCD1ff+5HLNeBGX60K1jRURijI3lNcyCASSrcz1iFmw9V+8xnRLzfH069hfmrzUAKc/zdpqmah4yXXVo/lpT1WoRa+5wn2YPZgKQMpk/o0egqtd8GIZUlqUCEFX92DrqgTbG2HwBG+VO8bmkwnQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/mobile.png
// module id = 3rL6
// module chunks = 2